export const caseStudies = {
  'retail-support-agent': {
    industry: 'Retail',
    type: 'Conversational Agent',
    title: 'A WhatsApp agent handling 3,000+ customer queries a day',
    outcome: '3,000+ queries/day handled automatically',
    summary:
      'A retail business drowning in repetitive WhatsApp support questions deployed a Liceron conversational agent integrated with their order system.',
    problem:
      'The support team spent most of their day answering the same questions: “Where’s my order?”, “How do I return this?”, “Is this in stock?”. Response times stretched to hours, and the team had no capacity for complex issues.',
    built:
      'A WhatsApp Business agent trained on the catalog, policies, and past conversations — wired directly into the order management system. It answers order, return, and stock questions, takes action where needed, and escalates anything it can’t resolve with full context.',
    results: [
      '80% of incoming queries resolved without a human',
      'Average response time: hours → seconds',
      'Support team refocused on complex, high-value cases',
    ],
    stack: ['WhatsApp Business API', 'Order Management API', 'Claude', 'Custom escalation logic'],
  },
  'logistics-invoice-agent': {
    industry: 'Logistics',
    type: 'Workflow Agent',
    title: 'Invoice processing cut from 4 days to 4 hours',
    outcome: 'Invoice processing: 4 days → 4 hours',
    summary:
      'A logistics company automated its manual invoice intake, validation, and routing with a Liceron workflow agent.',
    problem:
      'Invoices arrived in inconsistent formats, were keyed in by hand, and routed through email chains for approval — taking days and introducing errors.',
    built:
      'A workflow agent that ingests invoices, extracts and validates fields, matches them against purchase orders, routes exceptions for approval, and syncs everything to the accounting system — with a full audit log.',
    results: [
      'Processing time: 4 days → 4 hours',
      'Manual data entry eliminated',
      'Error rate reduced dramatically with automated validation',
    ],
    stack: ['Document AI', 'Accounting API', 'Approval workflow engine', 'OpenAI'],
  },
  'market-research-agent': {
    industry: 'Market Intelligence',
    type: 'Research Agent',
    title: 'Daily competitor reports with zero manual work',
    outcome: 'Daily competitor reports, zero manual work',
    summary:
      'A market intelligence firm replaced manual competitor research with a Liceron data agent running on a schedule.',
    problem:
      'Analysts manually checked competitor sites for pricing and product changes, then compiled reports — slow, inconsistent, and easy to miss things.',
    built:
      'A research agent that monitors competitor sources daily, detects changes, extracts structured data, and delivers a formatted report to the team — automatically, every morning.',
    results: [
      'Daily reports delivered with zero manual effort',
      'Changes caught the day they happen',
      'Analysts freed for higher-value analysis',
    ],
    stack: ['Web monitoring', 'Structured extraction', 'Scheduled pipelines', 'Email digest'],
  },
};

export const caseStudyOrder = [
  'retail-support-agent',
  'logistics-invoice-agent',
  'market-research-agent',
];
